module.exports = __webpack_public_path__ + "img/banner-pets.499dfbaf.png";